module.exports = __webpack_public_path__ + "static/media/third-slide.7b736ab2.webp";